import { render, staticRenderFns } from "./patientManagementDetails.vue?vue&type=template&id=d830d5aa&scoped=true&"
import script from "./patientManagementDetails.vue?vue&type=script&lang=js&"
export * from "./patientManagementDetails.vue?vue&type=script&lang=js&"
import style0 from "./patientManagementDetails.vue?vue&type=style&index=0&id=d830d5aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d830d5aa",
  null
  
)

export default component.exports